// import { Component, OnInit } from '@angular/core';
import {Component,HostListener,Directive,HostBinding,Input, OnInit, OnDestroy} from '@angular/core';
import { Router, NavigationEnd, NavigationStart } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';

import {  ViewEncapsulation, ViewChild, ElementRef, PipeTransform, Pipe } from '@angular/core';
import { DomSanitizer } from "@angular/platform-browser";

@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) { }
  transform(url) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}




@Component({
    selector: 'app-my-app',
    templateUrl: './app.component.html'
})

export class AppComponent implements OnInit, OnDestroy {
  
  @HostListener('window:beforeunload')
  async ngOnDestroy() {
    // if (this.myUserSub) {
    //   this.myUserSub.unsubscribe();
    // }
    // await this.authService.logout();
    alert("window:unload");
    //console.log("test yyy");
  }

  @HostListener('window:unload', [ '$event' ])
  unloadHandler(event) {
    alert("window:unload")
  }

  @HostListener('window:beforeunload', [ '$event' ])
  beforeUnloadHander(event) {
    // ...
    alert("window:beforeunload");
  }


  private _router: Subscription;
  title = 'app';

  video: string = "https://www.youtube.com/embed/CD-E-LDc384"
  constructor( private router: Router ) {
    //this.validateUserMAO = false;
  }

  //  ngOnDestroy(){
  //    alert("funciona al cerrar la ventana");
  //  }

    ngOnInit() {
      this._router = this.router.events.filter(event => event instanceof NavigationEnd).subscribe((event: NavigationEnd) => {
        const body = document.getElementsByTagName('body')[0];
        const modalBackdrop = document.getElementsByClassName('modal-backdrop')[0];
        if (body.classList.contains('modal-open')) {
          body.classList.remove('modal-open');
          modalBackdrop.remove();
        }
      });
    }
}
